import { useEffect, useState } from "react";

import { MyButton } from "../../components";
import { Col, Row, Input, Select, Grid,Form, Empty, DatePicker, Image} from "antd";
import { StyledCard, StyledSelect } from './style';
import { MyText } from "../../components";
import {useTranslation} from "react-i18next";
import { EditOutlined, DeleteOutlined, CalendarOutlined, UserOutlined, ManOutlined, WomanOutlined } from '@ant-design/icons';
import { fetchAddChildAction, fetchChildrensAction, fetchCitiesListAction, fetchDeleteChildAction, fetchDistrictsListAction, fetchGetProfile, fetchModules, fetchRegionsListAction, fetchUpdateChildAction, fetchUpdateProfileAction } from "../../utils";
import {useDispatch, useSelector} from "react-redux";
import { RootState, selectStore } from "../../utils";
import { useNavigate } from "react-router-dom";
import { useEmbeddedNavigate } from "../../utils/context/embed";
import dayjs from "dayjs";
import localeRu from "antd/es/date-picker/locale/ru_RU";
import localeKz from "antd/es/date-picker/locale/kk_KZ";
import { useLang } from "../../utils/context/lang";

export const ProfilePage = () => {
  const {t} = useTranslation("common")
  const { Option } = Select;
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [regions, setRegions] = useState([]);
  const [genders, setGenders] = useState([
    { id: 1, name: t("boy") },
    { id: 2, name: t("girl") },
  ]);
  const childrensList = useSelector((state: any) => state.materials.childrens);
  const childrens = childrensList.data?.children || [];
  const loading = childrensList.loading;
  const updateProfile = useSelector((state: any) => state.materials?.updateProfile ?? { loading: false });
  const addChild = useSelector((state: any) => state.materials?.addChild ?? { loading: false });
  const updateChild = useSelector((state: any) => state.materials?.updateChild ?? { loading: false });
  // const [childrens, setChildrens] = useState([]);
  const regionsList = useSelector((state: any) => state.materials?.regionsList ?? { data: null, loading: false });
  const districtsList = useSelector((state: any) => state.materials?.districtsList ?? { data: null, loading: false });
  const citiesList = useSelector((state: any) => state.materials?.citiesList ?? { data: null, loading: false });

  const [form] = Form.useForm();
  const [formChild] = Form.useForm();
  const {handleChangeLang, lang} = useLang()

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const navigate = useNavigate();
  const embeddedNavigate = useEmbeddedNavigate();

  const [cities, setCities] = useState([]);
  const [districts, setDistricts] = useState([]);

  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [showDistrict, setShowDistrict] = useState(true);
  const [showSettlement, setShowSettlement] = useState(true);
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();
  const dispatch = useDispatch();
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [isButtonChildDisabled, setIsButtonChildDisabled] = useState(true);
  const [editingChild, setEditingChild] = useState(null);
  const [isInitializing, setIsInitializing] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [isSaved, setIsSaved] = useState(false);

  const { profile: { userData: userDataState}}: RootState = useSelector(selectStore);
  const dateFormat = 'DD/MM/YYYY';
  const [formData, setFormData] = useState({
      firstName: userDataState?.data?.first_name || '',
      lastName: userDataState?.data?.last_name || '',
      region: null,
      district: null,
      settlement: null,
    });

    const [formChildData, setFormChildData] = useState({
      firstName: userDataState?.data?.first_name || '',
      lastName: userDataState?.data?.last_name || '',
      dateOfBirth: null,
      gender: null
    });

  const regionInfo = userDataState?.data?.region_info;


// useEffect(() => {
//   const regionInfo = userDataState?.data?.region_info;

//   const regionId = regionInfo?.region_id;
//   const districtId = regionInfo?.district_id;
//   const cityId = regionInfo?.city_id;

//   if (regionId || districtId || cityId) {
//     const fetchInitialLocationData = async () => {
//       try {
//         setIsInitializing(true);

//         if (regionId) {
//           const regionData = regions.find(r => r.id === regionId);

//           let region = regionData;
//           if (!region) {
//             const response = await fetchRegions(); 
//             region = response?.items?.find(r => r.id === regionId);
//           }

//           const isRegionLocality = region?.type === 'locality';

//           form.setFieldsValue({ region: regionId });
//           setSelectedRegion(regionId);

//           if (isRegionLocality) {
//             setShowDistrict(false);
//             setShowSettlement(false);
//             form.setFieldsValue({ district: undefined, settlement: undefined });
//             return;
//           }

//           setShowDistrict(true);
//         }

//         if (districtId) {
//           const districtsResponse = await fetchRegions(regionId);
//           setDistricts(districtsResponse?.items || []);
//           form.setFieldsValue({ district: districtId });
//           setSelectedDistrict(districtId);
//         }

//         if (cityId) {
//           if (districtId || regionId) {
//             const parentId = districtId || regionId;
//             const citiesResponse = await fetchRegions(parentId);
//             setCities(citiesResponse?.items || []);
//             form.setFieldsValue({ settlement: cityId });
//           } else {
//             form.setFieldsValue({ region: cityId });
//           }
//         }
//       } catch (error) {
//         console.error('Ошибка при инициализации локации:', error);
//       } finally {
//         setIsInitializing(false);
//       }
//     };

//     fetchInitialLocationData();
//   }
// }, [userDataState]);

useEffect(() => {
  const regionInfo = userDataState?.data?.region_info;
  const regionId = regionInfo?.region_id;
  const districtId = regionInfo?.district_id;
  const cityId = regionInfo?.city_id;

  if (regionId || districtId || cityId) {
    setIsInitializing(true);

    if (regionId) {
      form.setFieldsValue({ region: regionId });
      setSelectedRegion(regionId);
    }
    if (districtId) {
      dispatch(fetchDistrictsListAction(regionId));
      form.setFieldsValue({ district: districtId });
      setSelectedDistrict(districtId);
    }
    if (cityId) {
      const parentId = districtId || regionId;
      if (parentId) {
        dispatch(fetchCitiesListAction(parentId));
        form.setFieldsValue({ settlement: cityId });
      } else {
        form.setFieldsValue({ region: cityId });
      }
    }

    setIsInitializing(false);
  }
}, [userDataState]);

  const handleInputChange = (field: string, value: string | boolean) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleChildInputChange = (field: string, value: string | boolean) => {
    setFormChildData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

// const fetchChildrensData = async () => {
//   try {
//     const response = await fetchGetChildrens();
//     setChildrens(response?.children);
//   } catch (error) {
//     console.error("Ошибка при получении детей", error);
//   }
// };

useEffect(() => {
  dispatch(fetchChildrensAction({}));
}, []);

// useEffect(() => {
//   fetchChildrensData();
// }, []);

useEffect(() => {
    const fetchContent = async () => {
        try {
            const response = await  dispatch(fetchGetProfile({
              onRegionNull: () => {
                embeddedNavigate('/register/confirm');
              }
            }))
            setProfileData(response);
        } catch (error) {
            console.error('Error fetching themes:', error);
        }
    };

    fetchContent();
}, []);

useEffect(() => {
  if (userDataState?.data?.first_name && userDataState?.data?.last_name) {
    const firstName = userDataState?.data?.first_name;
    const lastName = userDataState?.data?.last_name;
    setFormData((prev) => ({
      ...prev,
      firstName,
      lastName
    }));

    form.resetFields(['firstName', 'lastName']);
    form.setFieldsValue({ firstName, lastName });
  }
}, [userDataState, form]);

useEffect(() => {
  dispatch(fetchRegionsListAction());
}, []);

useEffect(() => {
  if (!regionsList.success || !regionsList.data) return;
  setRegions(regionsList.data?.items || []);
}, [regionsList.success, regionsList.data]);

useEffect(() => {
  if (!selectedRegion || isInitializing) return;
  dispatch(fetchDistrictsListAction(selectedRegion));
}, [selectedRegion, isInitializing]);

useEffect(() => {
  if (!districtsList.success || !districtsList.data) return;
  setDistricts(districtsList.data?.items || []);
}, [districtsList.success, districtsList.data]);

useEffect(() => {
  if (!selectedDistrict || isInitializing) return;
  dispatch(fetchCitiesListAction(selectedDistrict));
}, [selectedDistrict, isInitializing]);

useEffect(() => {
  if (!citiesList.success || !citiesList.data) return;
  setCities(citiesList.data?.items || []);
}, [citiesList.success, citiesList.data]);


//   useEffect(() => {
//     const fetchRegionsData = async () => {
//         try {
//             const response = await fetchRegions();
//             setRegions(response?.items);
//         } catch (error) {
//             console.error('Ошибка при получении регионов', error);
//         }
//     };
//     fetchRegionsData();
// }, []);

// useEffect(() => {
//   if (selectedRegion && !isInitializing) {
//     const fetchDistricts = async () => {
//       try {
//         const response = await fetchRegions(selectedRegion);
//         setDistricts(response?.items);
//       } catch (error) {
//         console.error('Ошибка при получении районов', error);
//       }
//     };
//     fetchDistricts();
//   }
// }, [selectedRegion, isInitializing]);


// useEffect(() => {
//   if (selectedDistrict && !isInitializing) {
//     const fetchCities = async () => {
//       try {
//         const response = await fetchRegions(selectedDistrict);
//         setCities(response?.items);
//       } catch (error) {
//         console.error('Ошибка при получении населённых пунктов', error);
//       }
//     };
//     fetchCities();
//   }
// }, [selectedDistrict, isInitializing]);

const handleRegionChange = (value: any) => {
  setSelectedRegion(value);
  setSelectedDistrict(null);
  setSelectedCity(null);

  form.setFieldsValue({
    district: null,
    settlement: null,
    region: value,
  });

  setFormData((prev) => ({ 
    ...prev, 
    region: value, 
    district: null, 
    settlement: null  
  }));
};

const handleDistrictChange = (value: any) => {
  setSelectedDistrict(value);
  setSelectedCity(null);

  form.setFieldsValue({
    district: value,
    settlement: null,
  });

  setFormData((prev) => ({ 
    ...prev, 
    district: value, 
    settlement: null 
  }));
};

const handleCityChange = (value: any) => {
  setSelectedCity(value);
  form.setFieldsValue({ settlement: value });

  setFormData((prev) => ({ 
    ...prev, 
    settlement: value 
  }));
};

  const handleSave = () => {
    if (newPassword !== confirmPassword) {
      setErrorMessage(t("PasswordsMismatch"));
    } else {
      setErrorMessage('');
      console.log('Password saved successfully');
    }
  };

//  const handleButtonClick = async () => {
//   setIsLoading(true);

//   const locality =
//     cities.find((item) => item.id === formData.settlement && item.type === 'locality') ||
//     districts.find((item) => item.id === formData.district && item.type === 'locality') ||
//     regions.find((item) => item.id === formData.region && item.type === 'locality');

//   const payload = {
//     first_name: formData.firstName,
//     last_name: formData.lastName,
//     region_id: locality?.id || null,
//   };

//   try {
//     await updateUserProfile(payload);
//     await dispatch(fetchModules({}))
//     await dispatch(fetchGetProfile({}));
//     // form.resetFields();
//     // setFormData({ firstName: "", lastName: "", region: null, district: null, settlement: null });
//     // setError(null);
//     // embeddedNavigate('/');
//   } catch (error) {
//     console.error('Ошибка при отправке заявки', error);
//     if (error?.response?.data?.errors) {
//       setError(error.response.data.errors);
//     }
//   } finally {
//     setIsLoading(false);
//   }
// };

const handleButtonClick = () => {
  const getLocality = () =>
    cities.find((item) => item.id === formData.settlement && item.type === 'locality') ||
    districts.find((item) => item.id === formData.district && item.type === 'locality') ||
    regions.find((item) => item.id === formData.region && item.type === 'locality');
  const locality = getLocality();

  dispatch(fetchUpdateProfileAction({
    profileData: {
      first_name: formData.firstName,
      last_name: formData.lastName,
      region_id: locality?.id || null,
    },
    withRefetch: true,
  }));
};

useEffect(() => {
  if (updateProfile.failed && updateProfile.data?.errors) {
    setError(updateProfile.data.errors);
  }
}, [updateProfile.failed]);

const isProfileLoading = updateProfile.loading;

const getYearLabel = (age: any) => { const lastDigit = age % 10; const lastTwoDigits = age % 100; if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return t("ages2"); if (lastDigit === 1) return t("ages1"); if (lastDigit >= 2 && lastDigit <= 4) return t("ages"); return t("ages2"); };
const getMonthLabel = (age: any) => { const lastDigit = age % 10; const lastTwoDigits = age % 100; if (lastTwoDigits >= 11 && lastTwoDigits <= 14) return t("months"); if (lastDigit === 1) return t("months2"); if (lastDigit >= 2 && lastDigit <= 4) return t("months1"); return t("months"); };

const formatAge = (ageInMonths: number) => {
  const years = Math.floor(ageInMonths / 12);
  const months = ageInMonths % 12;

  let result = "";

  if (years > 0) {
    result += `${years} ${getYearLabel(years)}`;
  }

  if (months > 0) {
    result += (result ? " " : "") + `${months} ${getMonthLabel(months)}`;
  }

  return result || t("months");
};

// const handleAddChildClick = async () => {
//   setIsLoading(true);

//   const payload = {
//     first_name: formChildData.firstName,
//     last_name: formChildData.lastName,
//     birth_date: dayjs(formChildData.dateOfBirth).format("YYYY-MM-DD"),
//     gender: formChildData.gender
//   };

//   try {
//     let response;

//     if (editingChild) {
//       response = await fetchUpdateChild(editingChild.id, payload);
//     } else {
//       response = await fetchAddChild(payload);
//     }

//     if (response?.errors) {
//       setIsButtonChildDisabled(false)
//       setError(response.errors);
//       return;
//     }

//     await dispatch(fetchModules({}));

//     formChild.resetFields();
//     setFormChildData({
//       firstName: "",
//       lastName: "",
//       dateOfBirth: null,
//       gender: null
//     });

//     setEditingChild(null);
//     setError(null);

//     // await fetchChildrensData();
//     dispatch(fetchChildrensAction({}))
//     // navigate("/profile");
//   } catch (error) {
//     console.error("Ошибка при отправке заявки", error);
//     if (error?.response?.data?.errors) {
//       setError(error.response.data.errors);
//     }
//   } finally {
//     setIsLoading(false);
//   }
// };

const handleAddChildClick = () => {
  const childData = {
    first_name: formChildData.firstName,
    last_name: formChildData.lastName,
    birth_date: dayjs(formChildData.dateOfBirth).format("YYYY-MM-DD"),
    gender: formChildData.gender,
  };

  if (editingChild) {
    dispatch(fetchUpdateChildAction({ id: editingChild.id, childData }));
  } else {
    dispatch(fetchAddChildAction({ childData }));
  }
};

useEffect(() => {
  if (!addChild.success && !updateChild.success) return;

  formChild.resetFields();
  setFormChildData({ firstName: "", lastName: "", dateOfBirth: null, gender: null });
  setEditingChild(null);
  setError(null);
}, [addChild.success, updateChild.success]);

useEffect(() => {
  if (!addChild.failed || !addChild.data) return;
  setError(addChild.data);
  setIsButtonChildDisabled(false);
}, [addChild.failed]);

useEffect(() => {
  if (!updateChild.failed || !updateChild.data) return;
  setError(updateChild.data);
  setIsButtonChildDisabled(false);
}, [updateChild.failed]);

const isChildLoading = addChild.loading || updateChild.loading;

useEffect(() => {
  const { firstName, lastName, dateOfBirth, gender } = formChildData;
  
  const isFormComplete =
    firstName &&
    lastName &&
    dateOfBirth &&
    gender

  setIsButtonChildDisabled(!isFormComplete);
}, [formChildData]);



useEffect(() => {
  const { firstName, lastName, region, district, settlement } = formData;
  const selectedRegion = regions.find(r => r.id === region);
  const selectedDistrict = districts.find(d => d.id === district);
  const selectedSettlement = cities.find(s => s.id === settlement);

  const hasLocalitySelected =
    (selectedRegion?.type === 'locality') ||
    (selectedDistrict?.type === 'locality') ||
    (selectedSettlement?.type === 'locality');

  const isFormComplete =
    firstName &&
    lastName &&
    (
      (region && district && settlement) ||
      hasLocalitySelected
    );

  const isTouched = form.isFieldsTouched(['firstName', 'lastName', 'region', 'district', 'settlement']);

  setIsButtonDisabled(!isFormComplete || !isTouched);
}, [formData, regions, districts, cities]);

useEffect(() => {
  if (!updateProfile.success) return;
  form.resetFields();
  form.setFieldsValue({
    firstName: formData.firstName,
    lastName: formData.lastName,
    region: formData.region,
    district: formData.district,
    settlement: formData.settlement,
  });
  setIsButtonDisabled(true);
}, [updateProfile.success]);

useEffect(() => {
  const currentRegionId = form.getFieldValue('region');
  const currentDistrictId = form.getFieldValue('district');

  const selectedRegion = regions.find(r => r.id === currentRegionId);
  const selectedDistrict = districts.find(d => d.id === currentDistrictId);

  const isRegionLocality = selectedRegion?.type === 'locality';
  const isDistrictLocality = selectedDistrict?.type === 'locality';

  if (isRegionLocality) {
    setShowDistrict(false);
    setShowSettlement(false);
    return;
  }

  setShowDistrict(true);
  setShowSettlement(!isDistrictLocality || !!regionInfo?.city_id);
}, [form, regions, districts, regionInfo]);


const handleEdit = (child: any) => {
  setShowForm(true)
  setEditingChild(child);
  formChild.setFieldsValue({
    firstName: child.first_name,
    lastName: child.last_name,
    dateOfBirth: dayjs(child.birth_date),
    gender: child.gender
  });
};

const handleAddNew = () => {
  formChild.resetFields();
    setFormChildData({
      firstName: "",
      lastName: "",
      dateOfBirth: null,
      gender: null
    });

    setEditingChild(null);
    setError(null);
};


  return (
    <Row justify='center'>
      <Col span={20}>
      <Form
              form={form}
              onFinish={handleSave}
              onValuesChange={(changedValues, allValues) => {
                  setFormData((prev) => ({
                    ...prev,
                    ...allValues,
                  }));
                }}
              // onFieldsChange={() => {
              //   const hasTouchedFields = form.isFieldsTouched(true);
              //   const hasErrors = form.getFieldsError().some(({ errors }) => errors.length);
                
              //   setIsButtonDisabled(!hasTouchedFields || hasErrors);
              // }}
              initialValues={{ firstName: formData.firstName, lastName: formData.lastName }}
            >
        <Row gutter={[32, 32]}>
          <Col span={24}>
            <MyText color='#0A033C' size={40} weight={800}
                    style={{ fontFamily: 'Nunito', display: 'block' }}>
              Профиль
            </MyText>
          </Col>

          <Col span={24}>
            <StyledCard style={{borderRadius: 20}}>
            
            <Col style={{padding: 32}}>
            
            <MyText color='rgba(10, 3, 60, 1)' size={32} weight={700}
                    style={{ fontFamily: 'Nunito', display: 'block' }}>
              {t('myData')}
            </MyText>
            <Row gutter={[24,screens.xs ? 0 : 36]} style={{marginTop: 24}}>

            <Col span={screens.xs ? 24 : 8}>
            <MyText color='rgba(71, 74, 87, 1)' size={22} weight={700}
                    style={{ fontFamily: 'Nunito', display: 'block' }}>
            {t("lastName")}
            </MyText>
            <Form.Item
              name="lastName"
              rules={[{ required: true, message: t('enterYourSurname') }]}
            >
              <Input 
                placeholder={t('enterYourSurname')} 
                onChange={(e) => handleInputChange('lastName', e.target.value)}
                style={{marginTop: 6, padding: 12 }}
              />
            </Form.Item>
            </Col>
            <Col span={screens.xs ? 24 : 8}>
            <MyText color='rgba(71, 74, 87, 1)' size={22} weight={700}
                    style={{ fontFamily: 'Nunito', display: 'block' }}>
            {t("firstName")}
            </MyText>
            <Form.Item
              name="firstName"
              rules={[{ required: true, message: t('enterYourName') }]}
            >
              <Input 
                placeholder={t('enterYourName')} 
                onChange={(e) => handleInputChange('firstName', e.target.value)}
                style={{marginTop: 6, padding: 12 }}
              />
            </Form.Item>
            </Col>
            <Col span={screens.xs ? 0 : 8}></Col>
            <Col span={screens.xs ? 24 : 8}>
            <MyText
                color="rgba(71, 74, 87, 1)"
                size={22}
                weight={700}
                style={{ fontFamily: 'Nunito', display: 'block' }}
            >
                {t("regionArea")}
            </MyText>
            <Form.Item
              name="region"
              rules={[{ required: true, message: t('selectFromList') }]}
            >
              <StyledSelect
                placeholder={t("selectFromList")}
                style={{ width: '100%',marginTop: 6, height: 52 }}
                value={selectedRegion}
                onChange={handleRegionChange}
              >
                {regions.map((region) => (
                  <Option key={region.id} value={region.id}>
                    {region.name}
                  </Option>
                ))}
              </StyledSelect>
            </Form.Item>
            </Col>
          {showDistrict && (
          <Col span={screens.xs ? 24 : 8}>
            <MyText
                color="rgba(71, 74, 87, 1)"
                size={22}
                weight={700}
                style={{ fontFamily: 'Nunito', display: 'block' }}
            >
                {t("regionDistrict")}
            </MyText>
            <Form.Item
              name="district"
              rules={[{ required: true, message: t('selectFromList') }]}
            >
              <StyledSelect
                placeholder={t("selectFromList")}
                style={{ width: '100%', marginTop: 6, height: 52 }}
                value={selectedDistrict}
                notFoundContent={<Empty imageStyle={{ height: 80 }} description={t("noData")} />}
                onChange={handleDistrictChange}
              >
                {districts.map((city) => (
                  <Option 
                    key={city.id} 
                    value={city.id} 
                    style={{ fontWeight: city.is_big === 1 ? 'bold' : 'normal' }}
                  >
                    {city.name}
                  </Option>
                ))}
              </StyledSelect>
            </Form.Item>
            </Col>
          )}

        {showSettlement && (
            <Col span={screens.xs ? 24 : 8}>
            <MyText
                color="rgba(71, 74, 87, 1)"
                size={22}
                weight={700}
                style={{ fontFamily: 'Nunito', display: 'block' }}
            >
                {t("settlement")}
            </MyText>
            <Form.Item
              name="settlement"
              rules={[{ required: true, message: t('selectFromList') }]}
            >
              <StyledSelect
                placeholder={t("selectFromList")}
                style={{ width: '100%', marginTop: 6, height: 52 }}
                value={selectedCity}
                notFoundContent={<Empty imageStyle={{ height: 80 }} description={t("noData")} />}
                onChange={handleCityChange}
              >
                {cities.map((city) => (
                  <Option 
                    key={city.id} 
                    value={city.id} 
                    style={{ fontWeight: city.is_big === 1 ? 'bold' : 'normal' }}
                  >
                    {city.name}
                  </Option>
                ))}
              </StyledSelect>
            </Form.Item>
            </Col>
        )}
            </Row>

            <Row justify="center" align="middle" style={{ marginTop: 16 }}>
            <MyButton 
              color="orange" 
              type="primary" 
              htmlType="submit"
              disabled={isButtonDisabled}
              onClick={handleButtonClick}
            > 
            {t("save")}
            </MyButton>
          </Row>
            </Col>
            </StyledCard>
          </Col>
        </Row>
        </Form>

      </Col>

      <Col span={20}>
      <Form
              form={formChild}
              onFinish={handleSave}
              onValuesChange={(changedValues, allValues) => {
                  setFormChildData((prev) => ({
                    ...prev,
                    ...allValues,
                  }));
                }}
            >

        <StyledCard style={{borderRadius: 20, marginTop: 32}}>
            <Col style={{padding: 32}}>
        <Row gutter={[32, 0]}>
          <Col span={24}>
            <MyText color='rgba(10, 3, 60, 1)' size={32} weight={700}
                    style={{ fontFamily: 'Nunito', display: 'block' }}>
            {t("myChildren")}
            </MyText>
          </Col>

          <Col span={24}>
          <Row gutter={[24, 24]} style={{ marginTop: 32 }}>

          {childrens?.length ? (
              childrens.map((child) => (
                <Col key={child.id} span={screens.xs ? 24 : 12}>

                  <Row justify='space-between' align="middle">
                  <Col span={18}>
                  <Row gutter={[8,8]} align="middle">
                  <Image
                    // src={child.gender === 1 ? BoyImage : GirlImage}
                    src={child?.avatar}
                    preview={false}
                    width={60}
                    height={60}
                    style={{marginRight: 12}}
                  />
                  <Col>
                  <MyText
                    color="rgba(10, 3, 60, 1)"
                    size={22}
                    weight={600}
                    style={{ fontFamily: "Nunito", display: "block", marginLeft: 4 }}
                  >
                    {child.first_name}
                  </MyText>
                  <Col>
                  <Row gutter={8}>
                    <Col>
                  <MyText
                    color="rgba(10, 3, 60, 1)"
                    size={14}
                    weight={600}
                    style={{ fontFamily: "Nunito", display: "block", marginTop: 6 }}
                  >
                    {/* {t("dateOfBirth")}:  */}
                    <CalendarOutlined style={{marginRight: 6}}/>
                    {dayjs(child.birth_date).format("DD.MM.YYYY")}
                  </MyText>
                  </Col>
                  <Col>
                  <MyText
                    color="rgba(10, 3, 60, 1)"
                    size={14}
                    weight={600}
                    style={{ fontFamily: "Nunito", display: "block", marginTop: 6 }}
                  >
                    {/* {t("age")}:  */}
                    <UserOutlined style={{marginRight: 6}}/>
                    ({formatAge(child.age_in_months)})
                  </MyText>
                  </Col>
                  <Col>
                    <MyText
                      color="rgba(10, 3, 60, 1)"
                      size={14}
                      weight={600}
                      style={{ fontFamily: "Nunito", display: "block", marginTop: 6 }}
                    >
                      {Number(child.gender) === 1 ? (
                        <ManOutlined style={{ marginRight: 6 }} />
                      ) : (
                        <WomanOutlined style={{ marginRight: 6 }} />
                      )}
                      {Number(child.gender) === 1 ? t("boy") : t("girl")}
                    </MyText>
                  </Col>
                  </Row>
                  </Col>
                  </Col>
                  </Row>
                </Col>
               <Row gutter={[8, 8]}>
                <Col>
                  <Row
                    align="middle"
                    justify="center"
                    style={{
                      height: 40,
                      width: 40,
                      background: "rgba(0, 0, 0, 0.04)",
                      cursor: "pointer",
                      borderRadius: 8,
                    }}
                    onClick={() => handleEdit(child)}
                  >
                    <EditOutlined style={{ fontSize: 20, color: "rgb(71, 74, 87)" }} />
                  </Row>
                </Col>

                <Col>
                  <Row
                    align="middle"
                    justify="center"
                    onClick={() => dispatch(fetchDeleteChildAction(child.id))}
                    style={{
                      height: 40,
                      width: 40,
                      background: "rgba(0, 0, 0, 0.04)",
                      cursor: "pointer",
                      borderRadius: 8,
                    }}
                  >
                    <DeleteOutlined style={{ fontSize: 20, color: "rgb(71, 74, 87)" }} />
                  </Row>
                </Col>
              </Row>

                  </Row>

                </Col>
              ))
            ) : (
              <Col span={24} style={{ marginTop: 32 }}>
                <MyText
                  color="rgba(71, 74, 87, 1)"
                  size={22}
                  weight={700}
                  style={{ fontFamily: "Nunito", display: "block" }}
                >
                  {t("noChildren")}
                </MyText>
              </Col>
            )}
          </Row>
          </Col>
          
           <Col span={24}>
      {!showForm ? (
        <MyButton
          color="orange"
          type="primary"
          onClick={() => setShowForm(true)}
          style={{ marginTop: 32 }}
        >
          {t("addChild")}
        </MyButton>
      ) : (
        <Row gutter={[24, 0]} style={{ marginTop: 32 }}>
          <Col span={screens.xs ? 24 : 6}>
            <MyText color="rgba(71, 74, 87, 1)" size={22} weight={700} style={{ fontFamily: "Nunito", display: "block" }}>
              {t("lastName")}
            </MyText>
            <Form.Item
              name="lastName"
              rules={[{ required: true }]}
              help={<span style={{ color: "red" }}>{error?.last_name?.[0]}</span>}
            >
              <Input
                placeholder={t("enterChildSurname")}
                onChange={(e) => handleChildInputChange("lastName", e.target.value)}
                style={{ marginTop: 6, padding: 12 }}
              />
            </Form.Item>
          </Col>

          <Col span={screens.xs ? 24 : 6}>
            <MyText color="rgba(71, 74, 87, 1)" size={22} weight={700} style={{ fontFamily: "Nunito", display: "block" }}>
              {t("firstName")}
            </MyText>
            <Form.Item
              name="firstName"
              rules={[{ required: true }]}
              help={<span style={{ color: "red" }}>{error?.first_name?.[0]}</span>}
            >
              <Input
                placeholder={t("childNamePlaceholder")}
                onChange={(e) => handleChildInputChange("firstName", e.target.value)}
                style={{ marginTop: 6, padding: 12 }}
              />
            </Form.Item>
          </Col>

          <Col span={screens.xs ? 24 : 6}>
            <MyText color="rgba(71, 74, 87, 1)" size={22} weight={700} style={{ fontFamily: "Nunito", display: "block" }}>
              {t("gender")}
            </MyText>
            <Form.Item
              name="gender"
              rules={[{ required: true }]}
              help={<span style={{ color: "red" }}>{error?.gender?.[0]}</span>}
            >
              <StyledSelect
                placeholder={t("selectGender")}
                style={{ width: "100%", marginTop: 6, height: 52 }}
              >
                {genders.map((gender) => (
                  <Option key={gender.id} value={gender.id}>
                    {gender.name}
                  </Option>
                ))}
              </StyledSelect>
            </Form.Item>
          </Col>

          <Col span={screens.xs ? 24 : 6}>
            <MyText color="rgba(71, 74, 87, 1)" size={22} weight={700} style={{ fontFamily: "Nunito", display: "block" }}>
              {t("dateOfBirth")}
            </MyText>
            <Form.Item
              name="dateOfBirth"
              rules={[{ required: true }]}
              help={<span style={{ color: "red" }}>{error?.birth_date?.[0]}</span>}
            >
              <DatePicker
                style={{ height: 53, width: "100%", marginTop: 6 }}
                defaultValue={dayjs("01/01/2019", dateFormat)}
                format={dateFormat}
                locale={lang === "kk" ? localeKz : localeRu}
                placeholder="ДД.ММ.ГГ"
              />
            </Form.Item>
          </Col>

          <Col>
            <MyButton
              color="orange"
              type="primary"
              disabled={isButtonChildDisabled}
              onClick={handleAddChildClick}
            >
              {editingChild ? t("save") : t("addChild")}
            </MyButton>
          </Col>

          {editingChild && (
            <Col>
              <MyButton
                color="orange"
                type="primary"
                onClick={handleAddNew}
              >
                {t("addChild")}
              </MyButton>
            </Col>
          )}
        </Row>
      )}
    </Col>


          
        </Row>
        </Col>
        </StyledCard>
          </Form>
          </Col>
    </Row>
  );
};
